import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Icon, Typography } from 'shared/ui'
import { getLabelAsNumberInternationalFormat } from 'shared/lib'
import { type CallContact } from 'entities/Call/model/CallContact'
import styles from '../styles.module.scss'

type IIncomingBottomContentProps = {
  item: CallContact
}

export const IncomingBottomContent: FC<IIncomingBottomContentProps> = observer(({ item }) => (
  <div className={styles.item__head} aria-label={'incomingHead'}>
    <Icon icon='arrowLeftDown' fontSize={13} color='var(--content-primary-tertiary)' />
    <Typography
      tag={'span'}
      className={styles.item__head__name}
      variant={'body-xs-regular'}
      color={'var(--content-primary-primary)'}
      ariaLabel={'incomingInboxName'}
    >
      {item.inbox_name}
    </Typography>
    <span className={styles.item__head__ellipse}>
      <Icon icon='ellipse_6' fontSize={2} />
    </span>
    <Typography
      ellipsis
      tag={'span'}
      className={styles.item__head__number}
      variant={'body-xs-regular'}
      color={'var(--content-primary-tertiary)'}
      ariaLabel={'incomingInboxNumber'}
    >
      {item.inbox_number ??
        getLabelAsNumberInternationalFormat(item.number) ??
        item.formatted_number}
    </Typography>
  </div>
))
